<template>
  <div id="list-product" class="d-flex flex-column h-100">
    <div class="d-flex justify-content-between pt-2 header">
      <h3 class="mt-1 mx-auto"><b>Selecionar Colaborador</b></h3>
    </div>

    <div class="d-flex flex-column mt-1 px-2" style="padding-bottom: 75px">
      <b-tabs @activate-tab="toggleType">
        <b-tab :title="terms.salesRep">
          <ul class="w-100">
            <li class="search">
              <input-field v-model="search" placeholder="Buscar" @keyup="queueSearch" />
              <i class="icon-search" />
            </li>
            <li v-if="hasRequest" class="d-flex align-items-center">
              <b-spinner />
            </li>
          </ul>
        </b-tab>

        <b-tab title="Colaboradores" v-if="showManagers">
          <ul class="w-100">
            <li class="search">
              <input-field v-model="search" placeholder="Buscar" @keyup="queueSearch" />
              <i class="icon-search" />
            </li>
            <li v-if="hasRequest" class="d-flex align-items-center">
              <b-spinner />
            </li>
          </ul>
        </b-tab>
      </b-tabs>

      <ul class="w-100" v-if="this.items">
        <li v-for="(item, index) in items" :key="item.id" @click="select(item.id)">
          <div class="user-list-item">
            <user-item v-model="items[index]" />
            <div class="user-ws-status">
              <span :class="item.websocket_status" class="status-dot" />
            </div>
          </div>
        </li>
      </ul>
      <div class="w-100" v-if="this.showEmptyMessage">
        <h5 class="pt-2">
          <b
            >Nenhum
            {{ this.isOthers ? "colaborador" : terms.salesRep }}
            ativo nesse Workspace.</b
          >
        </h5>
        <h6 class="pt-1">
          <b>Dica:</b> O
          {{ this.isOthers ? "colaborador" : terms.salesRep }}
          se torna ativo no CRIM após o seu primeiro acesso na platforma.
        </h6>
        <img src="@/assets/images/no-data-illustration.svg" />
      </div>
      <div v-if="this.search.length > 3 && !this.items.length && !this.showEmptyMessage">
        <h4 class="mt-4">
          Nenhum
          {{ this.isOthers ? "colaborador" : terms.salesRep }}
          encontrado para essa busca.
        </h4>
        <img src="@/assets/images/no-data-illustration.svg" />
      </div>
    </div>
    <div class="cancelButtonDiv">
      <b-button @click="cancel" class="cancelButton"> Cancelar </b-button>
    </div>
  </div>
</template>
<script>
import { BButton, BSpinner, BTabs, BTab } from "bootstrap-vue";
import InputField from "./InputField.vue";
import UserItem from "./UserItem.vue";

export default {
  components: { InputField, BButton, UserItem, BSpinner, BTabs, BTab },

  data() {
    return {
      search: "",
      items: [],
      hasRequest: false,
      queueingSearch: 0,
      isOthers: false,
      showEmptyMessage: false,
    };
  },

  props: {
    showManagers: {
      type: Boolean,
      default: true,
    },

    workspaceId: {
      type: [Number, String],
    },
  },

  created() {
    this.hasRequest = true;

    this.fetchUsers();
  },

  computed: {
    allRoles() {
      return this.$store.getters["userStore/getRoles"];
    },

    terms() {
      return this.$store.getters["admin/getTerms"];
    },

    websocketUpdateEvents() {
      return this.$store.state.omnichannelSocket.updates;
    },
  },

  watch: {
    websocketUpdateEvents() {
      this.handleWSUserUpdate();
    },
  },

  methods: {
    queueSearch() {
      window.clearTimeout(this.queueingSearch);
      this.hasRequest = true;
      this.queueingSearch = setTimeout(() => {
        this.fetchUsers();
      }, 1000);
    },

    addUserParamsForSelector(params) {
      const mainCollaborator = this.$store.getters["whiteLabel/getPlatform"].settings.main_collaborator;

      if (this.isOthers) {
        let roles = this.allRoles.filter((role) => role.id != mainCollaborator && !role.isApi);

        if (this.role != "admin" && this.role != "ceo" && this.role != "auxiliarTi") {
          roles = roles.filter((role) => role.id != "admin" && role.id != "ceo" && role.id != "auxiliarTi");
        }

        roles.forEach((element) => {
          params.push({ query: "role" + "[]", param: element.id });
        });
      } else {
        params.push({ query: "role", param: mainCollaborator });
      }

      return params;
    },

    handleWSUserUpdate() {
      const lastEvent = this.websocketUpdateEvents[this.websocketUpdateEvents.length - 1];

      if (lastEvent.event === "USER_PRESENCE_UPDATED") {
        const userId = lastEvent.data.user_id;
        const status = lastEvent.data.status;

        const userIndex = this.items.findIndex((user) => user.id === userId);

        if (userIndex !== -1) {
          this.$set(this.items[userIndex], "websocket_status", status);
        }
      }
    },

    async fetchUsers() {
      let params = [
        {
          query: "limit",
          param: 100,
        },
        {
          query: "search",
          param: this.search,
        },
        {
          query: "operational_status",
          param: "Working",
        },
        {
          query: "workflow_id",
          param: this.$service.getWorkflowId(),
        },
      ];

      params = this.addUserParamsForSelector(params);

      if (this.search.length < 3 && this.search.length > 0) {
        this.hasRequest = false;
        return;
      }

      await this.$store
        .dispatch("app/fetchUsersFromOtherWorkspace", {
          workspaceId: this.workspaceId,
          params: this.$service.formatQueryParam(params),
        })
        .then((p) => {
          this.items = p.data;
          this.hasRequest = false;

          if (this.items.length == 0 && !this.search.length && !this.hasRequest) {
            this.showEmptyMessage = true;
          } else {
            this.showEmptyMessage = false;
          }
        });
    },

    cancel() {
      this.$bvModal.hide("bv-user-list");
    },

    select(selectedId) {
      const selectedItem = this.items.filter((item) => item.id === selectedId)[0];

      this.$emit("selectedUser", selectedItem);
      this.$bvModal.hide("bv-user-list");
    },

    toggleType() {
      this.isOthers = !this.isOthers;
      this.hasRequest = true;
      this.showEmptyMessage = false;
      this.fetchUsers();
    },
  },
};
</script>

<style lang="scss" scoped>
#list-product {
  :deep(.nav-tabs) {
    .nav-item {
      display: flex;
      flex-flow: column;
      flex-grow: 1;

      &:first-child {
        .nav-link {
          border-right: none;
        }
      }

      .nav-link {
        border: 1px solid #c4ccd8;
        &.active {
          padding-bottom: calc(8.54px + 1px);
          border-bottom: none;
        }
        &:after {
          border-bottom: 3px solid #046af3 !important;
          background: transparent !important;
        }
      }
    }
  }

  ul {
    border: 1px solid #e5e5e5;
    border-bottom: none;
    padding: 0;
    margin: 0;

    li.search {
      padding: 0px;
      margin: 0px;

      .input-field-container {
        padding: 0px;
        margin: 0px;
        :deep(input) {
          border: none;
        }
      }
      .icon-search {
        position: absolute;
        right: 40px;
        line-height: 45px;
      }
    }
    li {
      list-style: none;
      border-bottom: 1px solid #e5e5e5;
      padding: 9px;
      display: flex;
      flex-direction: column;

      &:hover {
        font-weight: 500;
        box-shadow: 1px 1px 4px 1px #a5a5a53d;
      }
    }
  }
}

.user-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.user-ws-status {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-left: 8px;

  .status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .online {
    background: #2ed47a;
  }

  .offline {
    background: #ff2c55;
  }

  .idle {
    background: #f8aa00;
  }
}

.cancelButtonDiv {
  justify-content: center;
  display: flex;
  position: fixed;
  max-width: 500px;
  border: 1px solid #d9d9d9;
  bottom: 0;
  width: 100%;
  padding: 5px;
  background: #fff;
  .cancelButton {
    background: transparent !important;
    color: black !important;
    border: none !important;
    box-shadow: none !important;
  }
}
</style>
